import {
  memberAPI
} from '../request';
export default {
  extractPersonalData: () => memberAPI.post('personal-data/extract'),
  deletePersonalData: () => memberAPI.post('personal-data/delete')
};
